import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

class VerDpto2 extends React.Component {
  state={
    argsDocum: {
      codigoDpto: this.props.idLista.codigoDpto,
      descrDptoAnt: this.props.idLista.descrDpto,
      descrDpto: this.props.idLista.descrDpto,
      codigoDptoDANE: this.props.idLista.codigoDptoDANE,
      _id: this.props.idLista._id
    },
    confirmaAct: false,
    open: false
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      if(ev.target.name !== "codigoDpto"){
        const argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.value
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;
    // console.log(this.state)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Tipo de cliente
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%" >
                  <Form.Field>
                    <label style={this.props.styles.label}>Código</label>
                    <Form.Input autoComplete="off" name="codigoDpto" id="codigoDpto" value={argsDocum.codigoDpto} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoDpto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrDpto" id="descrDpto" value={this.props.permiteUpdate?argsDocum.descrDpto:this.props.idLista.descrDpto} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrDpto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código departamento DANE</label>
                    <Form.Input autoComplete="off" name="codigoDptoDANE" id="codigoDptoDANE" value={this.props.permiteUpdate?argsDocum.codigoDptoDANE:this.props.idLista.codigoDptoDANE} onChange={this.handleChange} placeholder='Código departamento DANE' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoDptoDANE'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>

                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

                  {
                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerDpto2
